// Require

const { id, log } = require("../std/index")


//
// Tooltip
//
// Hover tooltip
//

module.exports = class TooltipWidget {
  constructor($host, config) {
    this.dom = {
      main: $host,
      tooltip: $('<div class="tooltip-inner">' + (config.tooltipText || "") + '</div>')
    };

    this.dom.main.append(this.dom.tooltip);

    this.dom.main.on('click', () => this.dom.tooltip.fadeIn());
    this.dom.main.on('mouseleave', () => this.dom.tooltip.fadeOut());
  }
};
